import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  sortByBtn: {
    '& span': {
      display: 'inline-block',
      marginLeft: '0.5rem',
    },
    '&:hover, &:focus': {
      color: `rgb(${theme.palette.white})`,
      outline: 0,
    },
    alignItems: 'center',
    background: 'transparent',
    border: 0,
    color: `rgb(${theme.palette.silver})`,
    cursor: 'pointer',
    display: 'flex',
    flexWrap: 'nowrap',
    fontSize: '0.875rem',
    justifyContent: 'center',
    letterSpacing: '0.11em',
    textTransform: 'uppercase',
    transition: `color ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      flexDirection: 'row',
    },
  },
  sortByBtnX: {
    color: `rgb(${theme.palette.doveGray})`,
  },
  sortBySection: {
    flex: '1 0 100%',
    [theme.breakpoints.up('md')]: {
      flex: '0 0 auto',
    },
  },
}))

export default useStyles
